import React from 'react'
import styles from './style.module.scss'

// [다음] 이 잠긴 이유 한 줄 — 푸터에 둔다. 잠금 판정과 문구가 같은 함수(getMappingBlockReason)에서 나온다(spec D2)
export const MappingBlockNotice = ({ reason, t }) => {
  if (!reason) return null
  /* i18next-extract-disable-next-line */
  const message = t(reason.key, reason.params)
  return (
    <p className={styles.blockNotice} role="status">
      {message}
    </p>
  )
}

// 헤더 옆 `n/N 단계` — indicator 는 getStepIndicator 의 결과({ current, total } 또는 null)(spec D3)
export const StepIndicator = ({ indicator, t }) => {
  if (!indicator) return null
  return (
    <span className={styles.stepIndicator}>{t('record.import.v2.stepIndicator', indicator)}</span>
  )
}
